export default __webpack_public_path__ + "static/media/foote-2.b2f5c106.png";